import React, {useState, forwardRef, useMemo} from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames/bind';
import keyCodes from 'js/shared/keyCodes';

import styles from './ModulePreview.module.scss';

const cx = classnames.bind(styles);

const ModulePreview = function ({className, icon, values, onClick}, ref) {
  const [focusedElement, setFocusedEelement] = useState(null);
  const onModuleClick = function (e) {
    onClick && onClick(e);
  };

  const onInputKeyUp = function (e, el) {
    if (e.keyCode === keyCodes.enter) {
      el?.onSubmit && el.onSubmit(e.target.value);
    }
  };

  const hasEditableValues = useMemo(() => {
    return values.some((item) => !item.readOnly);
  }, [values]);

  const content = (
    <>
      <i className={cx('icon', `icon-${icon}`)} />
      {values.map((el, i) => (
        <span key={i} className={cx('value-wrap', {empty: !el.value, focus: focusedElement === i})}>
          <span className={cx('value-label')}>{el.label}</span>
          {!el.readOnly && (
            <>
              <label htmlFor={el.id} className={cx('value-label')}>{el.label}</label>
              <input
                value={el.value}
                id={el.id}
                name={el.name}
                autoComplete="off"
                onChange={(e) => el.onChange(e.target.value)}
                onKeyUp={(e) => onInputKeyUp(e, el)}
                onFocus={() => setFocusedEelement(i)}
                onBlur={() => setFocusedEelement(null)}
                className={cx('value')}
              />
            </>
          )}
          {el.readOnly && (
            <>
              <span className={cx('value-label')}>{el.label}</span>
              <span key={i} className={cx('value')}>{el.value}</span>
            </>
          )}
        </span>
      ))}
    </>
  );

  if (hasEditableValues) {
    return (
      <div className={cx('root', className)} ref={ref} onClick={onModuleClick}>
        {content}
      </div>
    );
  }

  return (
    <button type="button" className={cx('root', className)} ref={ref} onClick={onModuleClick}>
      {content}
    </button>
  )
}

ModulePreview.propTypes = {
  className: PropTypes.string,
  icon: PropTypes.string.isRequired,
  values: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string.isRequired,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    readOnly: PropTypes.bool,
  })),
  onClick: PropTypes.func,
}

export default forwardRef(ModulePreview);
